'use client';

import React, { createContext } from 'react';
import { useSearchParams } from 'next/navigation';
import { useAccount } from 'frontastic';
import { UseAccountReturn } from 'frontastic/hooks/useAccount/types';

const AccountContext = createContext({} as UseAccountReturn);

const AccountProvider = ({ children }: React.PropsWithChildren) => {
  const searchParams = useSearchParams();

  const hasGmsbToken = Boolean(searchParams.get('token'));
  const accountReturn = useAccount(!hasGmsbToken);

  return <AccountContext.Provider value={accountReturn}>{children}</AccountContext.Provider>;
};

export { AccountContext, AccountProvider };

